import Vue from 'vue';
import env from '@/configs/env';
import App from './App.vue';
import router from './router';
import store from './store';

if (env.production) Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
